export default class {
    constructor (moment) {
        this.moment = moment;
    }

    isPassedTimeStamp (timestamp) {
        return this.moment().unix() > timestamp;
    }

    isPassedDate (date, granularity = 'day') {
        return this.moment.utc(date).isBefore(this.moment.utc(), granularity);
    }

    isCurrentDate (date, granularity = 'day') {
        return this.moment.utc(date).isSame(this.moment.utc(), granularity);
    }

    getCurrentDate (format = 'DD.MM.YYYY') {
        return this.moment.utc().format(format);
    }

    getTimezoneOffset (timezone) {
        const offsetHours = this.moment().tz(timezone).utcOffset() / 60;
        return offsetHours < 0 ? offsetHours : `+${offsetHours}`;
    }

    /**
     *
     * @param {string} date date that is being formatted
     * @param {string} [inputFormat=DD.MM.YYYY] optional input date format
     * @param {string} [format] optional output date format, defaults to DD.MM.YYYY
     * @returns {string} input date formatted into correct format
     */
    formatDate (date, inputFormat, format = 'DD.MM.YYYY') {
        return date ? this.moment(date, inputFormat).format(format) : '';
    }

    format (datetime, format = 'DD.MM.YYYY HH:mm') {
        return datetime ? this.moment.utc(datetime).local().format(format) : '';
    }

    formatTimeStamp (timestamp, format = 'DD.MM.YYYY HH:mm', keepUTC) {
        if (!timestamp) {
            return '';
        }
        let moment = this.moment.unix(timestamp);
        if (keepUTC) {
            moment = moment.utc();
        }
        return moment.format(format);
    }

    /**
     *
     * @param {string} date
     * @param {string} format
     */
    convertLocalTimeToUtc (date, format = 'YYYY-MM-DD HH:mm:ss') {
        const localTime = `${date} 23:59:59`;
        return this.moment(localTime).utc().format(format);
    }

    /**
     *
     * @param {string} datetime
     * @param {string} timezone
     * @param {string} format
     */
    convertToTimezone (datetime, timezone, format = 'YYYY-MM-DD HH:mm:ss') {
        return this.moment(datetime).tz(timezone).format(format);
    }

    /**
     *
     * @param {string} datetime
     * @param {string} format
     */
    convertToUtc (datetime, format = 'YYYY-MM-DD HH:mm:ss') {
        return this.moment(datetime).utc().format(format);
    }

    /**
     * Parse date with strict format validation to avoid deprecation warnings coming from safari
     *
     * @param {string} date
     * @param {string} format
     * @param {boolean} strict - parsing to avoid deprecation warnings
     * @returns {object} - Moment object
     */
    parseDate (date, format = 'YYYY-MM-DD', strict = true) {
        return this.moment(date, format, strict);
    }

    /**
     * Combines date and time strings and converts to UTC format
     * Replacing convertToTimezone function, Specifically addresses the datePassed deprecation warning
     * @param {string} date
     * @param {string} time
     * @param {string} inputFormat
     * @param {string} outputFormat
     * @returns {string} - Formatted date-time string in UTC
     */
    parseDateTimeToUTC (date, time, inputFormat = 'YYYY-MM-DD HH:mm:ss', outputFormat = 'YYYY-MM-DD HH:mm:ss') {
        // Use strict parsing to avoid deprecation warnings
        return this.moment(`${date} ${time}`, inputFormat, true)
            .tz('UTC')
            .format(outputFormat);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/moment/index.js